/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavRecord = {
  readonly id?: number;
  firm: number;
  company: number;
  date: string;
  status?: DailyNavRecord.status | null;
  reviewed_by_scalar?: boolean;
  discussed_with_fund?: boolean;
  price_adjusted?: boolean;
  review_notes?: string | null;
  measurement_date?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace DailyNavRecord {
  export enum status {
    IN_PROGRESS = 'in_progress',
    REVIEWED = 'reviewed',
    RECOMMENDED = 'recommended',
    NOT_RECOMMENDED = 'not_recommended',
  }
}

